import React from 'react'
import styles from './Modal.scss'
import {base} from 'lib/styleguide/base.scss'
import cx from 'classnames'
import {Icon} from 'common/Icon'

export class Modal extends React.PureComponent {
  // TODO: prop to disable internal scrolling and extend modal to fit content
  static defaultProps = {
    contentPadding: true,
    showCloseButton: true,
    theme: {}
  }

  render () {
    const {
      className,
      children,
      footer,
      title,
      subtitle,
      contentPadding,
      onRequestClose,
      showCloseButton,
      bodyRef,
      theme,
      hideOverflow
    } = this.props

    return (
      <div className={cx(styles.Modal, base, className, theme.Modal)} ref={r => { this._modal = r }}>
        {title && <div className={cx(styles.header, theme.header)} ref={r => { this._header = r }}>
          <div className={cx(styles.inner, theme.inner)}>
            <h2>{title}</h2>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>
        </div>}
        <div ref={bodyRef} className={cx(styles.body, hideOverflow && styles.hideOverflow)}>
          <div className={cx(contentPadding && styles.inner)}>
            {children}
          </div>
        </div>
        {footer && <div className={styles.footer} ref={r => { this._footer = r }}>
          <div className={styles.inner}>
            {footer}
          </div>
        </div>}
        {showCloseButton && <a className={cx(styles.closeButton, theme.closeButton)} onClick={onRequestClose}>
          <Icon i='ios-close' size={32} />
        </a>}
      </div>
    )
  }
}

export class TwoCTAFooter extends React.PureComponent {
  render () {
    const {children} = this.props

    return <div className={styles.TwoCTAFooter}>
      {children}
    </div>
  }
}
